(function () {
  if (window.__murphyExternalVideosBound) return;
  window.__murphyExternalVideosBound = true;

  const posterChecks = new Map();

  const posterIsUsable = (url) => {
    if (!url) return Promise.resolve(false);
    if (posterChecks.has(url)) return posterChecks.get(url);

    const check = new Promise((resolve) => {
      const image = new Image();
      image.onload = () => resolve(image.naturalWidth > 0);
      image.onerror = () => resolve(false);
      image.src = url;
    });

    posterChecks.set(url, check);
    return check;
  };

  const applyVerifiedPoster = (element) => {
    if (!element || element.__murphyPosterApplied) return;
    const url = element.getAttribute('data-murphy-poster');
    if (!url) {
      element.__murphyPosterApplied = true;
      if (element.tagName === 'VIDEO') element.removeAttribute('poster');
      return;
    }

    element.__murphyPosterApplied = true;
    posterIsUsable(url).then((usable) => {
      if (element.tagName === 'VIDEO') {
        if (usable) {
          element.setAttribute('poster', url);
        } else {
          element.removeAttribute('poster');
        }
        return;
      }

      if (usable) {
        element.src = url;
        element.hidden = false;
      } else {
        element.removeAttribute('src');
        element.hidden = true;
      }
    });
  };

  const applyMurphyPosters = () => {
    document.querySelectorAll('video.murphy-external-video[data-murphy-poster]').forEach(applyVerifiedPoster);
    document.querySelectorAll('img.murphy-external-video-poster[data-murphy-poster]').forEach(applyVerifiedPoster);
  };

  const isMurphyVideoTarget = (target) =>
    Boolean(target && target.closest && target.closest('video.murphy-external-video'));

  const stopGalleryGesture = (event) => {
    if (isMurphyVideoTarget(event.target)) {
      event.stopPropagation();
    }
  };

  const pauseMurphyVideos = () => {
    document.querySelectorAll('video.murphy-external-video').forEach((video) => {
      const slide = video.closest('.product__media-item');
      if (slide && slide.classList.contains('is-active')) return;
      video.pause();
      video.removeAttribute('data-was-playing');
    });
  };

  const bindGalleries = () => {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.__murphyVideoBound) return;
      gallery.__murphyVideoBound = true;
      gallery.addEventListener('slideChanged', pauseMurphyVideos);
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (viewer) viewer.addEventListener('slideChange', pauseMurphyVideos);
    });
  };

  document.addEventListener('pointerdown', stopGalleryGesture, true);
  document.addEventListener('touchstart', stopGalleryGesture, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest('.thumbnail, .slider-button, .product__modal-opener, .product-media-modal')) {
      applyMurphyPosters();
      setTimeout(pauseMurphyVideos, 0);
      setTimeout(pauseMurphyVideos, 650);
    }
  });

  const initMurphyVideos = () => {
    applyMurphyPosters();
    bindGalleries();
    const observer = new MutationObserver(() => applyMurphyPosters());
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMurphyVideos);
  } else {
    initMurphyVideos();
  }
})();
